import { addDurationVital, addTiming } from "./integrations/datadog"

/* Includes set of north start performance metrics that we manually track */

export function trackCollectionPageNavigation(
  startTime: number,
  duration: number,
) {
  void addDurationVital("navigation.collectionPage", {
    startTime,
    duration,
  })
}

export function trackCurrenciesPageNavigation(
  startTime: number,
  duration: number,
) {
  void addDurationVital("navigation.currenciesPage", {
    startTime,
    duration,
  })
}

export function trackStatsPageNavigation(startTime: number, duration: number) {
  void addDurationVital("navigation.statsPage", {
    startTime,
    duration,
  })
}

export function trackTokenStatsPageNavigation(
  startTime: number,
  duration: number,
) {
  void addDurationVital("navigation.tokenStatsPage", {
    startTime,
    duration,
  })
}

export function trackSwapPageNavigation(startTime: number, duration: number) {
  void addDurationVital("navigation.swapPage", {
    startTime,
    duration,
  })
}

export function trackDiscoverPageNavigation(
  startTime: number,
  duration: number,
) {
  void addDurationVital("navigation.discoverPage", {
    startTime,
    duration,
  })
}

export function trackDropsPageNavigation(startTime: number, duration: number) {
  void addDurationVital("navigation.dropsPage", {
    startTime,
    duration,
  })
}

export function trackProfilePageNavigation(
  startTime: number,
  duration: number,
) {
  void addDurationVital("navigation.profilePage", {
    startTime,
    duration,
  })
}

export function trackProfileOffersPageNavigation(
  startTime: number,
  duration: number,
) {
  void addDurationVital("navigation.profilePage.offers", {
    startTime,
    duration,
  })
}

export function trackProfileListingsPageNavigation(
  startTime: number,
  duration: number,
) {
  void addDurationVital("navigation.profilePage.listings", {
    startTime,
    duration,
  })
}

export function trackProfileTokensPageNavigation(
  startTime: number,
  duration: number,
) {
  void addDurationVital("navigation.profilePage.tokens", {
    startTime,
    duration,
  })
}

export function trackProfileCreatedPageNavigation(
  startTime: number,
  duration: number,
) {
  void addDurationVital("navigation.profilePage.created", {
    startTime,
    duration,
  })
}

export function trackProfilePortfolioPageNavigation(
  startTime: number,
  duration: number,
) {
  void addDurationVital("navigation.profilePage.portfolio", {
    startTime,
    duration,
  })
}

export function trackProfileGalleriesPageNavigation(
  startTime: number,
  duration: number,
) {
  void addDurationVital("navigation.profilePage.galleries", {
    startTime,
    duration,
  })
}

export function trackProfileTokenWatchlistPageNavigation(
  startTime: number,
  duration: number,
) {
  void addDurationVital("navigation.profilePage.tokenWatchlist", {
    startTime,
    duration,
  })
}

export function trackProfileWatchlistPageNavigation(
  startTime: number,
  duration: number,
) {
  void addDurationVital("navigation.profilePage.watchlist", {
    startTime,
    duration,
  })
}

export function trackProfileFavoritesPageNavigation(
  startTime: number,
  duration: number,
) {
  void addDurationVital("navigation.profilePage.favorites", {
    startTime,
    duration,
  })
}

export function trackProfileActivityPageNavigation(
  startTime: number,
  duration: number,
) {
  void addDurationVital("navigation.profilePage.activity", {
    startTime,
    duration,
  })
}

export function trackCollectionItemsPagination(
  startTime: number,
  duration: number,
) {
  void addDurationVital("pagination.collectionItems", {
    startTime,
    duration,
  })
}

export function trackCollectionItemsLoaded() {
  void addTiming("loaded.collectionItems")
}
